<template>
  <div
    v-if="hasSubscription && restaurant.subscription_status !== 'cancelled'"
    class="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg"
  >
    <h4 class="text-sm font-medium text-red-900 dark:text-red-200 mb-2">
      {{ t('app.sysadmin.modal.cancel_subscription') }}
    </h4>
    <p class="text-sm text-red-700 dark:text-red-300 mb-3">
      {{ t('app.sysadmin.modal.cancel_warning') }}
    </p>
    <div class="flex gap-2">
      <button
        :disabled="loading"
        class="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50"
        @click="handleCancelSubscription(false)"
      >
        {{ t('app.sysadmin.modal.cancel_at_period_end') }}
      </button>
      <button
        :disabled="loading"
        class="px-4 py-2 text-sm bg-red-800 text-white rounded-lg hover:bg-red-900 disabled:opacity-50"
        @click="handleCancelSubscription(true)"
      >
        {{ t('app.sysadmin.modal.cancel_immediately') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Restaurant {
  subscription_status?: string;
}

const { t } = useI18n();

defineProps<{
  hasSubscription: boolean;
  restaurant: Restaurant;
  loading: boolean;
}>();

const emit = defineEmits<{
  (e: 'cancel-subscription', immediate: boolean): void;
}>();

const handleCancelSubscription = (immediate: boolean) => {
  emit('cancel-subscription', immediate);
};
</script>
